// client/src/SetupPage.jsx
import { useState } from "react";
import { api } from "./api.js";

const FONT = "'DM Sans', system-ui, sans-serif";
const MONO = "'JetBrains Mono', monospace";

export function SetupPage({ user, onOrgCreated, onOrgJoined, onLogout }) {
  const [mode, setMode] = useState("create"); // create | join
  const [name, setName] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (!name.trim()) { setError("Enter a team name."); return; }
    setLoading(true); setError("");
    try {
      const org = await api.createOrg(name.trim());
      onOrgCreated(org);
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const handleJoin = async () => {
    if (!inviteCode.trim()) { setError("Enter an invite code."); return; }
    setLoading(true); setError("");
    try {
      const org = await api.joinOrg(inviteCode.trim());
      onOrgJoined(org);
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const inp = {
    width: "100%", padding: "11px 14px", borderRadius: 8,
    border: "1px solid #e2e8f0", background: "#fff", color: "#1e293b",
    fontSize: 14, fontFamily: FONT, outline: "none", boxSizing: "border-box",
  };
  const infoBox = { background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "10px 12px", fontSize: 11, color: "#2563eb", lineHeight: 1.6, marginBottom: 16 };
  const errorBox = { background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 12px", fontSize: 12, color: "#dc2626", marginBottom: 14 };
  const label = { display: "block", fontSize: 11, fontWeight: 600, color: "#64748b", fontFamily: MONO, letterSpacing: "0.5px", marginBottom: 5 };

  return (
    <div style={{ minHeight: "100vh", background: "#f4f6fb", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ width: 440, maxWidth: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ width: 48, height: 48, borderRadius: 12, background: "linear-gradient(135deg, #3b82f6, #8b5cf6)", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 20, fontWeight: 800, color: "#fff", boxShadow: "0 8px 24px rgba(59, 130, 246, 0.3)", marginBottom: 12 }}>OC</div>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: "#1e293b", fontFamily: FONT, marginBottom: 4 }}>Welcome, {user.displayName}</h2>
          <p style={{ fontSize: 13, color: "#64748b" }}>Set up your team to get started</p>
        </div>

        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 14, padding: 28, boxShadow: "0 4px 16px rgba(15, 23, 42, 0.06)" }}>
          <div style={{ display: "flex", gap: 4, marginBottom: 24 }}>
            {[["create", "Create Team"], ["join", "Join a Team"]].map(([k, l]) => (
              <button key={k} onClick={() => { setMode(k); setError(""); }}
                style={{ flex: 1, padding: "10px 0", borderRadius: 7, border: `1px solid ${mode === k ? "#2563eb" : "#e2e8f0"}`, background: mode === k ? "#eff6ff" : "transparent", color: mode === k ? "#2563eb" : "#64748b", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: FONT }}>
                {l}
              </button>
            ))}
          </div>

          {mode === "create" ? (
            <div>
              <div style={{ marginBottom: 14 }}>
                <label style={label}>TEAM NAME</label>
                <input style={inp} value={name} onChange={e => { setName(e.target.value); setError(""); }} placeholder="e.g. SageCrest Advisory Team" />
              </div>
              <div style={infoBox}>
                You'll get an invite code to share with team members so they can join.
              </div>
              {error && <div style={errorBox}>{error}</div>}
              <button onClick={handleCreate} disabled={loading}
                style={{ width: "100%", padding: "12px 0", borderRadius: 8, border: "none", background: "linear-gradient(135deg, #3b82f6, #8b5cf6)", color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: FONT, boxShadow: "0 4px 16px rgba(59, 130, 246, 0.25)", opacity: loading ? 0.7 : 1 }}>
                {loading ? "Creating..." : "Create Team"}
              </button>
            </div>
          ) : (
            <div>
              <div style={{ marginBottom: 14 }}>
                <label style={label}>INVITE CODE</label>
                <input style={{ ...inp, fontFamily: MONO }} value={inviteCode} onChange={e => { setInviteCode(e.target.value); setError(""); }} placeholder="paste-invite-code-here" />
              </div>
              <div style={infoBox}>
                Ask your team admin for the invite code. It looks like a long alphanumeric string.
              </div>
              {error && <div style={errorBox}>{error}</div>}
              <button onClick={handleJoin} disabled={loading}
                style={{ width: "100%", padding: "12px 0", borderRadius: 8, border: "none", background: "linear-gradient(135deg, #22c55e, #16a34a)", color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: FONT, opacity: loading ? 0.7 : 1 }}>
                {loading ? "Joining..." : "Join Team"}
              </button>
            </div>
          )}
        </div>

        <div style={{ textAlign: "center", marginTop: 16 }}>
          <button onClick={onLogout} style={{ background: "none", border: "none", color: "#64748b", fontSize: 12, cursor: "pointer", fontFamily: FONT }}>Sign out</button>
        </div>
      </div>
    </div>
  );
}
